import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ToastStyled } from 'src/components';
import { duplicateCartAPI } from 'src/api/duplicateCartAPI';
import { useGetCartQuery } from 'src/hooks';

type Props = {
  cartId: string;
};

export const useDuplicateCart = ({ cartId }: Props) => {
  const cartQuery = useGetCartQuery({ cartId });

  const { t } = useTranslation();

  return useMutation({
    mutationFn: async () => duplicateCartAPI({ cart: cartQuery.data }),
    onSuccess: (data) => {
      window.location.href = `/make/${data}`;
    },
    onError: () => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='error'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          {t('common.something_went_wrong')}
        </ToastStyled>
      ));
    },
  });
};
